import { render } from "./AddArticleNumbers.vue?vue&type=template&id=4ed786b9"
import script from "./AddArticleNumbers.vue?vue&type=script&lang=js"
export * from "./AddArticleNumbers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__